import React, { useEffect } from 'react';
import {
  Navbar,
  HeroSection,
  FeaturesSection,
  ScreenshotsSection,
  DemoSection,
  GallerySection,
  CTASection,
  Footer,
} from '../components/landing';

const LandingPage = () => {
  useEffect(() => {
    document.title = 'XtraGlass - Discover Local, Travel Global! | Party & Nightlife';
  }, []);

  return (
    <main className="min-h-screen bg-[#0a0a0b]">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <ScreenshotsSection />
      <DemoSection />
      <GallerySection />
      <CTASection />
      <Footer />
    </main>
  );
};

export default LandingPage;